import React from 'react'

const CustomLoading = () => {
    return (
        <div className='absolute h-full w-full top-0 left-0 right-0 bottom-0 grid place-items-center z-[1000000000] backdrop-blur-sm bg-white/30'>
            <img src='https://res.cloudinary.com/di23omfvx/image/upload/v1692414437/loadingGif_figkhl.gif' className='h-50 w-80' alt='loading..' />
        </div>
    )
}

export default CustomLoading